var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-block-editor loop" }, [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.loopLoopType"))),
        ]),
        _vm._v(" "),
        _c("CustomPicker", {
          attrs: {
            items: _vm.loopType,
            idKey: "id",
            labelKey: "label",
            title: "Select Loop Type",
          },
          model: {
            value: _vm.clone.mode,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "mode", $$v)
            },
            expression: "clone.mode",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.loopTrimWhitespace"))),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.options.trimWhitespace,
            callback: function ($$v) {
              _vm.$set(_vm.clone.options, "trimWhitespace", $$v)
            },
            expression: "clone.options.trimWhitespace",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        key: "clone.options.iterationCounterStart",
        staticClass: "editor-row customize-editor-minimize",
      },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.loopLoopIterationCounterStart"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Loop Iteration Counter Start",
            "show-attributes": true,
            "automation-mode": "",
            "show-emoji": false,
          },
          model: {
            value: _vm.clone.options.iterationCounterStart,
            callback: function ($$v) {
              _vm.$set(_vm.clone.options, "iterationCounterStart", $$v)
            },
            expression: "clone.options.iterationCounterStart",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t(
                  "auto.loopACounterValueCalledLoopIterationWillBeAddedToEachIterationOfTheLoopDoesNotAffectTheDataToLoopThroughDefaultsTo0"
                )
              ) +
              "\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        key: "clone.options.maximumIterations",
        staticClass: "editor-row customize-editor-minimize",
      },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.loopMaxNumberOfLoopIteration"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Max Number of Loop Iteration",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.options.maximumIterations,
            callback: function ($$v) {
              _vm.$set(_vm.clone.options, "maximumIterations", $$v)
            },
            expression: "clone.options.maximumIterations",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t(
                  "auto.loopSetThisValueToLimitTheNumberOfLoopsPerformedDataInIterationsPastTheLimitWillBeIgnoredANumberHigherThan500WillBeReducedTo500ANumberLessThan1WillHaltThisStep"
                )
              ) +
              "\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _vm.clone.mode === "numbers"
      ? _c(
          "div",
          {
            key: "clone.number.end",
            staticClass: "editor-row customize-editor-minimize",
          },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v(_vm._s(_vm.$t("auto.loopLoopIterationCounterEnd"))),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Loop Iteration Counter End",
                "show-attributes": true,
                "show-emoji": false,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.number.end,
                callback: function ($$v) {
                  _vm.$set(_vm.clone.number, "end", $$v)
                },
                expression: "clone.number.end",
              },
            }),
            _vm._v(" "),
            _c("small", { staticClass: "description" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t(
                      "auto.loopSetTheIterationNumberToEndTheLoopAtHereDefaultsTo1CannotBeLessThanLoopIterationCounterStart"
                    )
                  ) +
                  "\n        "
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.mode === "numbers"
      ? _c(
          "div",
          {
            key: "clone.number.increment",
            staticClass: "editor-row customize-editor-minimize",
          },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v(
                _vm._s(_vm.$t("auto.loopLoopIterationCounterIncrementAmount"))
              ),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Loop iteration counter increment amount",
                "show-attributes": true,
                "show-emoji": false,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.number.increment,
                callback: function ($$v) {
                  _vm.$set(_vm.clone.number, "increment", $$v)
                },
                expression: "clone.number.increment",
              },
            }),
            _vm._v(" "),
            _c("small", { staticClass: "description" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t(
                      "auto.loopSetTheAmountToIncrementTheCounterForEachIterationOfTheLoopDefaultsTo1CannotBe0OrNegativeMustBeAnWholeNumber"
                    )
                  ) +
                  "\n        "
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.mode === "line-items"
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize data-items" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v(_vm._s(_vm.$t("auto.loopLineItemSToLoop"))),
            ]),
            _vm._v(" "),
            _vm._l(_vm.clone.items || [], function (item, index) {
              return _c("DataItem", {
                key: index,
                on: {
                  delete: function () {
                    return _vm.clone.items.splice(index, 1)
                  },
                },
                model: {
                  value: _vm.clone.items[index],
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.items, index, $$v)
                  },
                  expression: "clone.items[index]",
                },
              })
            }),
            _vm._v(" "),
            _c(
              "SupsisButton",
              { attrs: { small: "", ghost: "" }, on: { click: _vm.addItem } },
              [_vm._v(" " + _vm._s(_vm.$t("auto.loopAddItem")))]
            ),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.mode === "text"
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize data-items" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v(_vm._s(_vm.$t("auto.loopTextToLoop"))),
            ]),
            _vm._v(" "),
            _vm._l(_vm.clone.items || [], function (item, index) {
              return _c("DataItem", {
                key: index,
                on: {
                  delete: function () {
                    return _vm.clone.items.splice(index, 1)
                  },
                },
                model: {
                  value: _vm.clone.items[index],
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.items, index, $$v)
                  },
                  expression: "clone.items[index]",
                },
              })
            }),
            _vm._v(" "),
            (_vm.clone.items || []).length < 1
              ? _c(
                  "SupsisButton",
                  {
                    attrs: { small: "", ghost: "" },
                    on: { click: _vm.addItem },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("auto.loopAddItem")))]
                )
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.mode === "text"
      ? _c(
          "div",
          {
            key: "clone.text.delimiter",
            staticClass: "editor-row customize-editor-minimize",
          },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v(_vm._s(_vm.$t("auto.loopTextDelimiter"))),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Text Delimiter",
                "show-attributes": true,
                "show-emoji": false,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.text.delimiter,
                callback: function ($$v) {
                  _vm.$set(_vm.clone.text, "delimiter", $$v)
                },
                expression: "clone.text.delimiter",
              },
            }),
            _vm._v(" "),
            _c("small", { staticClass: "description" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("auto.loopSupportsSpecialCharactersDefaultsTo")
                  ) +
                  " "
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }